<div class="rangeselectorprt">
    <div class="daterange">
        <mat-form-field class="example-form-field" appearance="outline">
        <mat-label>Date Range</mat-label>
            <mat-date-range-input
            [formGroup]="campaignOne"
            [rangePicker]="campaignOnePicker"
            [max]="today">
            <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart>
            <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #campaignOnePicker>
                <mat-date-range-picker-actions>
                    <button class="apply" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                    <button class="can" mat-button matDateRangePickerCancel>Cancel</button>
                </mat-date-range-picker-actions>
            </mat-date-range-picker>
        </mat-form-field>
    </div>
</div>


<div>
    <ul class="listcont">

        <li class="pointer" (click)="goto(1)">
            First Original Visit Date Time
            <span class="red">{{userDetails?.firstOriginalVisitDateTime | date : 'MMM-dd-YYYY h:mm a'}}</span>
        </li>
        <li class="pointer" (click)="goto(2)">
            First Original Visit Lead Source
            <span class="green">{{userDetails?.firstOriginalVisitLeadSource}}</span>
        </li>
        <li class="pointer" (click)="changeTabName('totalOpenLeads')">
            Total Open Leads
            <span class="orenge">{{userDetails?.totalOpenLeads | number}}</span>
        </li>
        <li class="pointer" (click)="changeTabName('totalCpl')">
            Total Cpl
            <span class="purple">{{userDetails?.totalCpl | number}}</span>
        </li>
        <li class="pointer" (click)="changeTabName('totalLeads')">
            Total Leads
            <span class="blue">{{userDetails?.totalLeads | number}}</span>
        </li>
        <li class="pointer" (click)="changeTabName('totalSales')">
            Total Sales
            <span class="blue">$ {{userDetails?.totalSales | number}}</span>
        </li>    
            <li *ngFor="let item of userDetails?.states">
                State
                <span class="green">{{item.state}}</span>
            </li>
    </ul>
</div>


<fury-page-layout mode="card">
    <fury-page-layout-header>
        <div class="top_heading">
            <fury-breadcrumbs [@fadeInRight]  current="Audience details"></fury-breadcrumbs>
        </div>
    </fury-page-layout-header>
    <fury-page-layout-content [@fadeInUp]>
        <div>
       
            <div class="tablewrapper">
                <fury-list name={{listTitle}} [columns]="soldLeadColumns" (filterChange)="onSoldFilterFilterChange($event)">
                    <div style="position: relative;" class="filter">
                        <button class="filter fury-column-filter" type="button" mat-icon-button (click)="leadShowFilter = !leadShowFilter">
                          <img src="../../../assets/img/filter.png" alt="filter"/>
                        </button>
                        <div class="filteringprt" *ngIf="leadShowFilter">
                          <form [formGroup]="leadFilterForm">
                          <h3 style="margin: 0;">Filter</h3>
                          <mat-form-field appearance="outline">
                            <mat-label>Search By</mat-label>
                            <mat-select formControlName="searchBy">
                              <mat-option *ngFor="let item of leadSerchByValue" [value]="item?.value">{{item.title}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label>Search Type</mat-label>
                            <mat-select formControlName="searchType">
                                <mat-option *ngFor="let item of commonService.searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div class="btnprt">
                            <button mat-button class="can-button" (click)="leadShowFilter = !leadShowFilter">Cancel</button>
                            <button mat-button class="sub-button" (click)="soldFilterChange()">Search</button>
                          </div>
                        </form>
                        </div>
                      </div>
                    <table [dataSource]="soldLeadList" mat-table>
                      
                        <ng-container matColumnDef="firstName">
                            <th mat-header-cell *matHeaderCellDef>First Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.firstName}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="lastName">
                            <th mat-header-cell *matHeaderCellDef>Last Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.lastName}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="emailAddress">
                            <th mat-header-cell *matHeaderCellDef>Email Address</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.emailAddress}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="source">
                            <th mat-header-cell *matHeaderCellDef>Source</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.source}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="soldAmount">
                            <th mat-header-cell *matHeaderCellDef>Sold Amount</th>
                            <td mat-cell *matCellDef="let element">
                                $ {{(element?.soldAmount | number) || 0}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="attempts">
                            <th mat-header-cell *matHeaderCellDef>Attempts</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.attempts || 0}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef>Address</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.address?.streetAddress}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="city">
                            <th mat-header-cell *matHeaderCellDef>City</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.address?.city}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="zip">
                            <th mat-header-cell *matHeaderCellDef>Zip</th>
                            <td mat-cell *matCellDef="let element">
                                {{element.address?.zip}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>Action</th>
                            <td mat-cell *matCellDef="let element">
                                <mat-icon (click)="navigateLeadDetails(element?.leadId)">remove_red_eye</mat-icon>
                            </td>
                        </ng-container>
                         
                        <tr *matHeaderRowDef="soldLeadVisibleColumns" mat-header-row></tr>
                        <tr *matRowDef="let row; columns: soldLeadVisibleColumns"
                            class="clickable route-animations-elements" mat-row>
                        </tr>
                    </table>
                    <div *ngIf="soldLeadList?.length === 0" style="padding: 10px 0; text-align:center;">
                        No data found.
                    </div>
                    <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="soldLeadPageSize" [length]="soldLeadTotalCount" [pageIndex]="soldLeadPageIndex" (page)="soldLeadPageSizeChange($event)"
                        showFirstLastButtons
                        [selectConfig] = "selectConfig"
                        [ngClass]="{'mat-pegig': soldLeadPageSize === 9999}"
                        aria-label="Select page of periodic elements">
                    </mat-paginator>  
                   
                </fury-list>
            </div>
            <div class="tablewrapper customtable" id="1">
                <h3>First Original Visit Date Time Data</h3>
                <table>
                    
                    <tr>
                        <th>Created At</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Country</th>
                        <th>Browser Info</th>
                        <th>OS Info</th>
                        <th>Ip Address</th>
                        <th>Utm Source</th>
                        <th>Internal Url</th>
                    </tr>
                    <tr>
                        <td>{{firstVisitDateTimeList?.createdAt | date : 'MMM-dd-YYYY h:mm a'}}</td>
                        <td>{{firstVisitDateTimeList?.city}}</td>
                        <td>{{firstVisitDateTimeList?.state}}</td>
                        <td>{{firstVisitDateTimeList?.country}}</td>
                        <td>{{firstVisitDateTimeList?.browserInfo}}</td>
                        <td>{{firstVisitDateTimeList?.osInfo}}</td>
                        <td>{{firstVisitDateTimeList?.ipAddress}}</td>
                        <td>{{firstVisitDateTimeList?.utmSource}}</td>
                        <td>{{firstVisitDateTimeList?.internalUrl}}</td>
                    </tr>
                    <p *ngIf="!firstVisitDateTimeList">No Data Found</p>
                </table>
            </div>
            <div class="tablewrapper customtable" id="2">
                <h3>First Original Visit Lead Source Data</h3>
                <table>
                    <tr>
                        <th>Title</th>
                        <th>Type</th>
                        <th>Utm Source</th>
                        <th>Api Key</th>
                        <th>Cpl</th>
                        <th>Phone Number</th>
                        <th>Referral Abbreviation</th>
                        <th>Url</th>
                    </tr>
                    <tr>
                        <td>{{firstOriginalVisitLeadSourceData?.title}}</td>
                        <td>{{firstOriginalVisitLeadSourceData?.type}}</td>
                        <td>{{firstOriginalVisitLeadSourceData?.utmSource}}</td>
                        <td>{{firstOriginalVisitLeadSourceData?.apiKey}}</td>
                        <td>{{firstOriginalVisitLeadSourceData?.cpl}}</td>
                        <td>{{firstOriginalVisitLeadSourceData?.phoneNumber}}</td>
                        <td>{{firstOriginalVisitLeadSourceData?.referralAbbreviation}}</td>
                        <td>{{firstOriginalVisitLeadSourceData?.url}}</td>
                    </tr>
                    <tr *ngIf="!firstOriginalVisitLeadSourceData">
                        <td colspan="7" style="text-align: center;">
                            <p>No Data Found</p>
                        </td>
                    </tr>
                    
                </table>
            </div>
            <div class="tablewrapper">
                <fury-list name="All Page Visits" [columns]="allPageVisitColumns" (filterChange)="onAllPageFilterChange($event)">
                    <div style="position: relative;" class="filter">
                        <button class="filter fury-column-filter" type="button" mat-icon-button (click)="allPageVisitShowFilter = !allPageVisitShowFilter">
                          <img src="../../../assets/img/filter.png" alt="filter"/>
                        </button>
                        <div class="filteringprt" *ngIf="allPageVisitShowFilter">
                          <form [formGroup]="allPageFilterForm">
                          <h3 style="margin: 0;">Filter</h3>
                          <mat-form-field appearance="outline">
                            <mat-label>Search By</mat-label>
                            <mat-select formControlName="searchBy">
                              <mat-option *ngFor="let item of allPageVisitSerchByValue" [value]="item?.value">{{item.title}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label>Search Type</mat-label>
                            <mat-select formControlName="searchType">
                                <mat-option *ngFor="let item of commonService.searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div class="btnprt">
                            <button mat-button class="can-button" (click)="allPageVisitShowFilter = !allPageVisitShowFilter">Cancel</button>
                            <button mat-button class="sub-button" (click)="getAnalyticsDetails()">Search</button>
                          </div>
                        </form>
                        </div>
                      </div>
                    <table [dataSource]="allPageVisits" mat-table>
    
                       <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef>Created At</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.createdAt | date : 'MMM-dd-YYYY h:mm a'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="city">
                            <th mat-header-cell *matHeaderCellDef>City</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.city}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="state">
                            <th mat-header-cell *matHeaderCellDef>State</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.state}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="country">
                            <th mat-header-cell *matHeaderCellDef>Country</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.country}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="browserInfo">
                            <th mat-header-cell *matHeaderCellDef>Browser Info</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.browserInfo}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="osInfo">
                            <th mat-header-cell *matHeaderCellDef>OS Info</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.osInfo}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="ipAddress">
                            <th mat-header-cell *matHeaderCellDef>Ip Address</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.ipAddress}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="utmSource">
                            <th mat-header-cell *matHeaderCellDef>Utm Source</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.utmSource}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="internalUrl">
                            <th mat-header-cell *matHeaderCellDef>Internal Url</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.internalUrl}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="referralUrl">
                            <th mat-header-cell *matHeaderCellDef>Referral Url</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.referralUrl}}
                            </td>
                        </ng-container>
                         
                        <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                        <tr *matRowDef="let row; columns: visibleColumns"
                            class="clickable route-animations-elements" mat-row>
                        </tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="allPageVisitsPageSize" [length]="allPageVisitsTotalCount" [pageIndex]="allPageVisitsPageIndex" (page)="pageSizeChange($event)"
                        showFirstLastButtons
                        [selectConfig] = "selectConfig"
                        [ngClass]="{'mat-pegig': allPageVisitsPageSize === 9999}"
                        aria-label="Select page of periodic elements">
                    </mat-paginator>
                   
                    
                    <div *ngIf="allPageVisits?.length === 0" style="padding: 10px 0; text-align:center;">
                        No data found.
                    </div>
                   
                </fury-list>
            </div>
            <div class="tablewrapper">
                <fury-list name="Page Visit Count" [columns]="pageVisitCountColumns" (filterChange)="visitCountFilterChange($event)">
                    <table [dataSource]="pageVisitCountList" mat-table>
                      
                        <ng-container matColumnDef="internalUrl">
                            <th mat-header-cell *matHeaderCellDef>Internal Url</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.internalUrl}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="pageVisits">
                            <th mat-header-cell *matHeaderCellDef>Page Visits</th>
                            <td mat-cell *matCellDef="let element">
                                {{element?.pageVisits}}
                            </td>
                        </ng-container>
                         
                        <tr *matHeaderRowDef="visitColumnVisibleColumns" mat-header-row></tr>
                        <tr *matRowDef="let row; columns: visitColumnVisibleColumns"
                            class="clickable route-animations-elements" mat-row>
                        </tr>
                    </table>
                    <div *ngIf="pageVisitCountList?.length === 0" style="padding: 10px 0; text-align:center;">
                        No data found.
                    </div>
                    <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="visitCountPageSize" [length]="visitCountTotalCount" [pageIndex]="visitCountPageIndex" (page)="visitCountPageSizeChange($event)"
                        showFirstLastButtons
                        [selectConfig] = "selectConfig"
                        [ngClass]="{'mat-pegig': visitCountPageSize === 9999}"
                        aria-label="Select page of periodic elements">
                    </mat-paginator>
                   
                </fury-list>
            </div>
        </div>
    </fury-page-layout-content>
   
   
</fury-page-layout>
